import axios from "axios";
import { endpoints } from "../apiConfig";
import React, { useEffect, useState } from "react";
import AlvnaBrand from "../components/AlvnaBrand";
import { getAuthHeader, getOperatorIdentity, getOperatorLoginRedirect } from "../session";
import { colors, fonts, space, radius } from "../theme";

export default function ManagerHome() {
  const [attendanceOn, setAttendanceOn] = React.useState(false);
  const [onlineOn, setOnlineOn] = React.useState(false);
  React.useEffect(() => {
    if (!getAuthHeader().Authorization) return;
    axios.get(endpoints.settings, { headers: getAuthHeader() }).then((res) => { setAttendanceOn(!!res.data.attendance_enabled); setOnlineOn(!!res.data.online_ordering_enabled); }).catch(() => {});
  }, []);
  const [staff, setStaff] = useState(null);

  useEffect(() => {
    if (!getAuthHeader().Authorization) {
      window.location.href = getOperatorLoginRedirect("manager");
      return;
    }
    setStaff(getOperatorIdentity());
  }, []);

  const logout = () => {
    const redirect = getOperatorLoginRedirect("manager");
    sessionStorage.removeItem("staff_token");
    sessionStorage.removeItem("staff");
    sessionStorage.removeItem("staff_tenant");
    localStorage.removeItem("token");
    localStorage.removeItem("tenant");
    window.location.href = redirect;
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>Manager Home</h1>
        <div style={{ display: "flex", alignItems: "center", gap: space[3] }}>
          {staff && <span style={styles.staffName}>{staff.name}</span>}
          <button style={styles.logoutBtn} onClick={logout}>Log Out</button>
        </div>
      </div>

      <div style={styles.buttonStack}>
        <a href="/waiter" style={styles.actionCard}>
          <span style={styles.iconBox}>
            <StoreIcon />
          </span>
          <span style={styles.actionLabel}>Open Waiter View</span>
        </a>
        <a href="/kitchen" style={styles.actionCard}>
          <span style={styles.iconBox}>
            <KitchenIcon />
          </span>
          <span style={styles.actionLabel}>Open Kitchen View</span>
        </a>
        <a href="/menu" style={{ ...styles.actionCard, ...styles.secondaryCard }}>
          <span style={{ ...styles.iconBox, ...styles.secondaryIconBox }}>
            <ManageIcon />
          </span>
          <span style={styles.actionLabel}>Manage Restaurant (Menu, Tables, Staff, Settings)</span>
        </a>
        {onlineOn && (
          <a href="/online-ordering" style={{ ...styles.actionCard, ...styles.secondaryCard }}>
            <span style={{ ...styles.iconBox, ...styles.secondaryIconBox }}>
              <ManageIcon />
            </span>
            <span style={styles.actionLabel}>Online Ordering (link, hours, payments, recent orders)</span>
          </a>
        )}
        {attendanceOn && (
          <a href="/attendance" style={{ ...styles.actionCard, ...styles.secondaryCard }}>
            <span style={{ ...styles.iconBox, ...styles.secondaryIconBox }}>
              <ManageIcon />
            </span>
            <span style={styles.actionLabel}>Attendance (who's clocked in, hours, payroll export)</span>
          </a>
        )}
      </div>

      <div style={styles.brandFooter}>
        <AlvnaBrand variant="compact" />
      </div>
    </div>
  );
}

function StoreIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l1.5-5h15L21 9" /><path d="M3 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0" />
      <path d="M4 9v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" /><path d="M9 21v-6h6v6" />
    </svg>
  );
}

function KitchenIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="12" rx="2" /><path d="M6 10h4M6 14h2" />
    </svg>
  );
}

function ManageIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  );
}

const styles = {
  page: { minHeight: "100vh", background: colors.darkBg, padding: space[5], display: "flex", flexDirection: "column", alignItems: "center" },
  header: { width: "100%", maxWidth: 500, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: space[6] },
  title: { fontFamily: fonts.display, color: colors.darkText, fontSize: 20, margin: 0 },
  staffName: { fontFamily: fonts.body, color: colors.textMuted, fontSize: 13 },
  logoutBtn: { background: "none", border: `1px solid ${colors.darkBorder}`, color: colors.darkText, borderRadius: radius.sm, padding: "6px 12px", fontSize: 12, cursor: "pointer" },
  buttonStack: { width: "100%", maxWidth: 500, display: "flex", flexDirection: "column", gap: space[3], marginTop: space[6] },
  actionCard: {
    display: "flex", alignItems: "center", gap: space[3],
    background: colors.darkSurface, border: `1px solid ${colors.darkBorder}`, borderRadius: radius.md,
    padding: space[4], textDecoration: "none", color: colors.darkText,
    transition: "border-color 0.15s ease, transform 0.1s ease",
  },
  secondaryCard: { opacity: 0.85 },
  iconBox: {
    width: 40, height: 40, borderRadius: radius.sm, background: colors.brandGradient,
    display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", flexShrink: 0,
  },
  secondaryIconBox: { background: colors.darkBorder },
  actionLabel: { fontFamily: fonts.display, fontWeight: 600, fontSize: 15 },
  brandFooter: { marginTop: space[6] },
};
